// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutColumn__wrapper___gWReu","dominant":"LayoutColumn__dominant___B1FJw"};